import React from 'react';
import { useFiltriEsperienze, nomeLeggibile } from '../../features/knowledge-management/hooks/useTassonomie.js';

/**
 * 13/10 — UAT-16: "Profilo dichiarato nel Self-Assessment".
 *
 * Mostra, nella scheda della risorsa, ciò che la persona ha dichiarato nel
 * Self-Assessment: certificazioni, settori e domini. Settori e domini sono
 * salvati come codici di tassonomia (SEC-/DOM-): a schermo si vedono solo i
 * nomi, mai i codici. Se il backend fornisce già `settori_nomi` / `domini_nomi`
 * si usano quelli; altrimenti il nome si ricava da GET /esperienze/filtri.
 * Un codice non presente in tassonomia viene omesso, non mostrato grezzo.
 */
const comeLista = (v) => {
  if (Array.isArray(v)) return v.map((x) => String(x || '').trim()).filter(Boolean);
  if (typeof v === 'string') return v.split(/[,;\n]/).map((x) => x.trim()).filter(Boolean);
  return [];
};

const unici = (a) => Array.from(new Set(a));

export default function ResourceProfiloSa({ resource }) {
  const { filtri } = useFiltriEsperienze();
  const profilo = resource?.profilo || null;

  const certificazioni = unici(comeLista(profilo?.certificazioni ?? resource?.anagrafica?.certificazioni));

  const nomi = (preparati, codici, albero) => {
    const dal = comeLista(preparati);
    if (dal.length) return unici(dal);
    return unici(comeLista(codici).map((c) => nomeLeggibile(albero, c)).filter(Boolean));
  };
  const settori = nomi(profilo?.settori_nomi, profilo?.settori, filtri?.settori);
  const domini = nomi(profilo?.domini_nomi, profilo?.domini, filtri?.domini);

  if (!certificazioni.length && !settori.length && !domini.length) return null;

  const riga = (etichetta, valori) => (valori.length > 0 && (
    <div style={{ marginTop: 2 }}>
      <span style={{ color: '#6B6963' }}>{etichetta}: </span>{valori.join(', ')}
    </div>
  ));

  return (
    <div style={{ fontSize: 12, color: '#3D3B36', marginTop: 10 }}>
      <div style={{ fontWeight: 600, marginBottom: 2 }}>Profilo dichiarato nel Self-Assessment</div>
      {riga('Certificazioni', certificazioni)}
      {riga('Settori', settori)}
      {riga('Domini', domini)}
    </div>
  );
}
